import {
  EXPORT_JSON_TEXT,
  IMPORT_JSON_TEXT,
  RESET_TO_DEFAULT_TEXT,
} from 'components/AiMode/constants';
import styles from './styles.module.scss';
import Separator from 'components/UI/Separator';
import { Button } from 'packages/radiant-react/button';
import { useStyleContext } from 'context/StyleContext';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';

const Footer = ({
  openDownloadModal,
  openPasteModal,
  setMessage,
}: {
  openDownloadModal: () => void;
  openPasteModal: () => void;
  setMessage: (message: string) => void;
}) => {
  const { resetToDefault } = useStyleContext();

  const handleResetToDefault = () => {
    resetToDefault();
    setMessage('Styles reset to default.');
  };

  return (
    <Vertical className={styles['footer-wrapper']}>
      <Separator orientation="horizontal" color={'var(--rd-sys-color-border-subtle)'} />
      <Vertical className={styles['button-container']}>
        <Button
          onClick={openDownloadModal}
          text={EXPORT_JSON_TEXT}
          type="primary"
          size="m"
          isFullWidth={true}
          className={styles['export-json-button']}
          retainFocusOnClick={false}
        />
        <Horizontal>
          <Button
            onClick={openPasteModal}
            text={IMPORT_JSON_TEXT}
            type="tertiary"
            size="s"
            isFullWidth={true}
            retainFocusOnClick={false}
          />
          <Separator
            orientation="vertical"
            color={'var(--rd-sys-color-border-subtle)'}
            style={{ top: '10px' }}
          />
          <Button
            onClick={handleResetToDefault}
            text={RESET_TO_DEFAULT_TEXT}
            type="tertiary"
            size="s"
            isFullWidth={true}
            tooltip={RESET_TO_DEFAULT_TEXT}
            retainFocusOnClick={false}
          />
        </Horizontal>
      </Vertical>
    </Vertical>
  );
};

export default Footer;
